/* Zip Scanners: suppress Shopify's dynamically injected Shop Promise module
   on ALL product pages. Preserve Shop Pay installments, checkout, SC options
   and the Zip same-day shipping timeline. */
(function () {
  "use strict";

  var targetSelectors = [
    ".delivery-promise__promise-container",
    "[class*='delivery-promise']",
    "[id*='delivery-promise']",
    "[class*='shop-promise']",
    "[id*='shop-promise']",
    "[class*='ShopPromise']",
    "[id*='ShopPromise']",
    "[data-shop-promise]",
    "[data-shop-promise-container]",
    "shop-promise",
    "shopify-shop-promise",
    "shopify-promise",
    "shopify-delivery-promise",
    "delivery-promise",
    "iframe[src*='shop-promise']",
    "iframe[src*='delivery-promise']"
  ].join(",");

  function isPromiseText(text) {
    if (!text) return false;
    var t = text.replace(/\s+/g, " ").trim();
    if (!t || t.length > 650) return false;
    var date = /arrives as soon as|trusted delivery|estimated delivery/i.test(t);
    var benefits = /free shipping over|returns accepted|free returns|shop\s*promise/i.test(t);
    var brand = /shop\s*promise/i.test(t);
    return (date && benefits) || (brand && /returns accepted|free returns|free shipping over/i.test(t));
  }

  function init() {
    if (!document.body || !document.body.classList.contains("template-product")) return;
    var product = document.querySelector("#shopify-section-product-template") ||
                  document.querySelector(".Product");
    if (!product) return;
    var addToCart = product.querySelector(".ProductForm__AddToCart");
    var observedRoots = new WeakSet();
    var pending = false;

    function safeToHide(el) {
      if (!el || el.nodeType !== 1 || !el.isConnected) return false;
      if (el === product || el === document.body) return false;
      if (el.closest(".zs-ship, .zip-product-financing, .bold_options, #judgeme_product_reviews")) return false;
      if (addToCart && el.contains(addToCart)) return false;
      return true;
    }

    function hide(el) {
      if (!safeToHide(el)) return false;
      if (el.getAttribute("data-zs-shop-promise-suppressed") === "true") return true;
      el.setAttribute("data-zs-shop-promise-suppressed", "true");
      el.setAttribute("aria-hidden", "true");
      el.style.setProperty("display", "none", "important");
      return true;
    }

    function processRoot(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll(targetSelectors).forEach(hide);

      /* Detect badges even when Shopify changes their CSS class names. */
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var node, count = 0;
      while ((node = walker.nextNode()) && count++ < 1600) {
        if (!/arrives as soon as|shop\s*promise|trusted delivery/i.test(node.nodeValue || "")) continue;
        var el = node.parentElement;
        for (var depth = 0; el && depth < 9; depth++, el = el.parentElement) {
          if (el === product || el === document.body) break;
          if (isPromiseText(el.textContent || "") && hide(el)) break;
        }
      }

      /* Detect open shadow-root renderers and watch them for delayed inserts. */
      root.querySelectorAll("*").forEach(function (el) {
        if (!el.shadowRoot) return;
        var shadow = el.shadowRoot;
        if (isPromiseText(shadow.textContent || "")) hide(el);
        watch(shadow);
      });
    }

    function scan() {
      pending = false;
      processRoot(product);
      /* Shopify occasionally injects the badge adjacent to the product form. */
      document.querySelectorAll(targetSelectors).forEach(function (el) {
        if (el.closest("#shopify-section-product-template")) hide(el);
      });
    }

    function schedule() {
      if (pending) return;
      pending = true;
      window.setTimeout(scan, 100);
    }

    function watch(root) {
      if (!root || observedRoots.has(root)) return;
      observedRoots.add(root);
      var observer = new MutationObserver(schedule);
      /* Ignore attribute changes so hiding a badge cannot recurse. */
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    }

    watch(product);
    scan();
    window.addEventListener("load", schedule, { once: true });
    document.addEventListener("change", function (event) {
      if (product.contains(event.target)) schedule();
    });
    [300, 1200, 3000, 6500].forEach(function (delay) {
      window.setTimeout(schedule, delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();